import React, { useState, useEffect } from "react";
import ReturnButton from "./ReturnButton";
import { supabase } from "./supabaseClient";

export default function Settings() {
  const [email, setEmail] = useState("");
  const [resetStatus, setResetStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  // Désabonnement
  const [unsubscribeStatus, setUnsubscribeStatus] = useState(null);
  const [unsubscribeLoading, setUnsubscribeLoading] = useState(false);

  // Pré-remplit l'email connecté au chargement
  useEffect(() => {
    const getEmail = async () => {
      const { data } = await supabase.auth.getUser();
      if (data?.user?.email) {
        setEmail(data.user.email);
      }
    };
    getEmail();
  }, []);

  // Fonction de demande de reset MDP
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setResetStatus(null);
    setLoading(true);

    if (!email) {
      setResetStatus({ type: "error", msg: "Veuillez renseigner votre e-mail." });
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password",
    });

    if (error) {
      setResetStatus({ type: "error", msg: "Erreur : " + error.message });
    } else {
      setResetStatus({
        type: "success",
        msg: "Un e-mail de réinitialisation a été envoyé. Vérifiez votre boîte de réception !",
      });
    }
    setLoading(false);
  };

  // Fonction de désabonnement : appel Edge Function Supabase avec AUTH
  const handleUnsubscribe = async () => {
    setUnsubscribeLoading(true);
    setUnsubscribeStatus(null);

    // On récupère le JWT de la session pour l'envoyer dans Authorization
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) {
      setUnsubscribeStatus({ type: "error", msg: "Session non trouvée (token manquant)" });
      setUnsubscribeLoading(false);
      return;
    }
    const userId = session.user.id;

    try {
      const response = await fetch(
        "https://airnerilsoslbjmivezu.supabase.co/functions/v1/clever-api",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: userId }),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || "Erreur inconnue");
      setUnsubscribeStatus({ type: "success", msg: result.message });
    } catch (err) {
      setUnsubscribeStatus({ type: "error", msg: err.message });
    }
    setUnsubscribeLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <ReturnButton />
      <div className="bg-white p-10 rounded-xl shadow-xl max-w-lg w-full">
        <h2 className="text-2xl font-bold mb-4">Paramètres du compte</h2>
        <div className="space-y-6">
          <div>
            <label className="block font-bold mb-1">Langue</label>
            <select className="border rounded px-4 py-2 w-full">
              <option>Français</option>
              <option>Anglais</option>
            </select>
          </div>
          <div>
            <label className="block font-bold mb-1">Adresse e-mail</label>
            <input
              type="email"
              className="border rounded px-4 py-2 w-full"
              value={email || "(non modifiable en ligne)"}
              disabled
            />
            <p className="text-sm text-gray-500 mt-1">
              Pour modifier votre adresse e-mail, merci de nous contacter :  
              <a href="mailto:vrepop.repub@gmail.com" className="text-blue-600">vrepop.repub@gmail.com</a>
            </p>
          </div>
          {/* Bloc réel de reset du mot de passe */}
          <div>
            <label className="block font-bold mb-1">Réinitialisation / changement mot de passe</label>
            <form onSubmit={handlePasswordReset} className="flex gap-2 flex-col sm:flex-row items-stretch sm:items-end">
              <input
                type="email"
                className="border rounded px-4 py-2 flex-1"
                placeholder="Votre e-mail de connexion"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 font-semibold"
                disabled={loading}
              >
                {loading ? "Envoi..." : "Recevoir le lien"}
              </button>
            </form>
            {resetStatus && (
              <div className={`mt-2 text-sm ${resetStatus.type === "success" ? "text-green-600" : "text-red-600"}`}>
                {resetStatus.msg}
              </div>
            )}
          </div>
          {/* Bloc abonnement/désabonnement avec message d'information */}
          <div>
            <button
              className={`bg-red-500 text-white px-6 py-2 rounded-lg font-semibold mt-4 ${unsubscribeLoading ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={handleUnsubscribe}
              disabled={unsubscribeLoading}
            >
              {unsubscribeLoading ? "Désabonnement..." : "Se désabonner"}
            </button>
            <div className="text-xs text-gray-500 mt-1 flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="orange" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2.25m0 4.5h.008v-.008H12v.008zm0 0A9 9 0 113 12a9 9 0 019 9z" />
              </svg>
              En cas de désabonnement, vous gardez l’accès à l’extension jusqu’à la date de fin de votre période payée.
            </div>
            {unsubscribeStatus && (
              <div className={`mt-2 text-sm ${unsubscribeStatus.type === "success" ? "text-green-600" : "text-red-600"}`}>
                {unsubscribeStatus.msg}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
